export default "__VITE_ASSET__Cqnd5O1d__"